
import { Typography, Box, Grid, RadioGroup, FormControlLabel, Radio, FormControl, Select, MenuItem, FormHelperText } from '@material-ui/core';
import { MobileRegularPage } from '../../../components';
import styles from './userinfo.style';
import { RepLIProviderTextField } from '../../../components';
import React, { } from 'react';
import { useTranslation } from "react-i18next";
import { feedbackIam } from "../../../data/db";


const UserInfo = props => {
    const classes = styles();
    const { t } = useTranslation();

    return (
        <MobileRegularPage>
            <Grid container>
                <Grid item xs={12} md={12}>

                    <Box xs={10} md={10}>
                        <RepLIProviderTextField
                            label="Name"
                            autoFocus
                            InputProps={{ readOnly: true }}
                            onChange={props.onUserNameChange}
                            value={props.userName}
                        />
                    </Box>

                    <Box item xs={10} md={10}>
                        <RepLIProviderTextField
                            label="E-mail"
                            autoFocus
                            InputProps={{ readOnly: true }}
                            onChange={props.onEmailChange}
                            value={props.email}
                            error={props.email && !props.isValidEmail}
                            helperText={!props.isValidEmail ? "Please enter valid email address" : ''}
                        />
                    </Box>

                    <Box xs={10} md={10}>
                        <RepLIProviderTextField
                            type="number"
                            label={`${t('common.form.label.age')}*`}
                            autoFocus
                            onChange={props.onAgeChange}
                            onInput={(e) => {
                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
                            }}
                            value={props.age}
                            error={props.submitted && !props.validator.fieldValid('age')}
                            helperText={props.validator.message('age', props.age, 'required')}
                        />
                    </Box>

                    <Box className={classes.inputSection}>
                        <Typography variant="h5" >I am*</Typography>
                        <FormControl variant="outlined"
                            component="fieldset"
                            error={props.submitted && !props.validator.fieldValid('role')}
                            fullWidth>
                            <Select value={props.role} onChange={props.onRoleChange}>
                                {feedbackIam.map(option =>
                                    <MenuItem key={option} value={option}>{option}</MenuItem>
                                )}
                            </Select>
                            <FormHelperText style={{ textAlign: "center" }}>
                                {props.validator.message('role', props.role, 'required')}
                            </FormHelperText>
                            {props.role === "Other" &&
                                <RepLIProviderTextField
                                    label="Please fill the other response*"
                                    value={props.otherRole}
                                    inputProps={{ maxLength: 2500 }}
                                    onChange={e => props.onOtherRoleChange(e, "Other Role")}
                                    autoFocus
                                    error={props.submitted && !props.validator.fieldValid('otherRole')}
                                    helperText={props.validator.message('otherRole', props.otherRole, `field_req:${props.role}`)}
                                />
                            }
                        </FormControl>
                    </Box>

                    {props.email && props.isValidEmail &&
                        <Box className={classes.inputSection}>
                            <Typography variant="h5" >May we contact you about your responses ?*</Typography>
                            <FormControl
                                component="fieldset"
                                error={props.submitted && !props.validator.fieldValid('Contact')}
                            >
                                <RadioGroup display="flex" row label={t('common.feedbackForm.contactAboutResponse')}
                                    value={props.canContact}
                                    onChange={props.canContactChange}
                                >
                                    <FormControlLabel control={<Radio color="primary" />} value="yes" label="Yes" />
                                    <FormControlLabel control={<Radio color="primary" />} value="no" label="No" />
                                </RadioGroup>
                            </FormControl>
                            <FormHelperText error style={{ textAlign: "center" }}>
                                {props.validator.message('Contact', props.canContact, 'required')}
                            </FormHelperText>
                        </Box>
                    }
                </Grid>
            </Grid>
        </MobileRegularPage>
    )
};

export default UserInfo